import React from 'react';
import './footer.css';
import Linkedin from '../../assets/linkedin.png';
import Github from '../../assets/github2.png';
import Instagram from '../../assets/instagram.png';

const Footer = () => {
  return (
    <section id="footer">
        <div className="links">
            <a href="https://www.linkedin.com/in/praneelseth">
                <img src={Linkedin} alt="LinkedIn" className="icon"/>
            </a>
            <a href="https://www.github.com/praneelseth">
                <img src={Github} alt="Github" className="icon"/>
            </a>
            <a href="https://www.instagram.com/praneelseth">
                <img src={Instagram} alt="Instagram" className="icon"/>
            </a>
        </div>
    </section>
  )
}

export default Footer;
